export const pageTypes = {
	SET_PLAYER: 'SET_PLAYER',
	SET_PUBLIC_LAST_MATCH_SOURCE: 'SET_PUBLIC_LAST_MATCH_SOURCE',
	SET_PUBLIC_MATCH_HISTORY: 'SET_PUBLIC_MATCH_HISTORY',
	SET_RANK: 'SET_RANK',
	SET_DIAGRAM_RATINGS: 'SET_DIAGRAM_RATINGS',
	SET_ROLE: 'SET_ROLE',
	SET_RATINGS: 'SET_RATINGS',
	SET_AIM_RATINGS: 'SET_AIM_RATINGS',
	SET_AIM_ROLE: 'SET_AIM_ROLE',
	SET_AIM_RANK_STATS: 'SET_AIM_RANK_STATS',
	SET_DIAGRAM_RANK_STATS: 'SET_DIAGRAM_RANK_STATS',
	SET_LAST_MATCH_INFO: 'SET_LAST_MATCH_INFO',
	SET_RANK_STATS: 'SET_RANK_STATS',
	SET_PLAYERS_RANK_STATS: 'SET_PLAYERS_RANK_STATS',
	SET_CARDS_STATS: 'SET_CARDS_STATS',
	SET_RANK_STATS_V2: 'SET_RANK_STATS_V2',
	SET_PLAYER_CLIPS: 'SET_PLAYER_CLIPS',
	SET_PLAYER_PLACEHOLDER_CLIPS: 'SET_PLAYER_PLACEHOLDER_CLIPS',
	SET_UTILITY_RATINGS: 'SET_UTILITY_RATINGS',
	SET_UTILITY_ROLE: 'SET_UTILITY_ROLE',
	SET_UTILITY_RANK_STATS: 'SET_UTILITY_RANK_STATS',
	SET_RANK_TO_RATINGS: 'SET_RANK_TO_RATINGS',
};

export const setPlayer = (payload) => ({
	type: pageTypes.SET_PLAYER,
	payload,
});

export const setPublicLastMatchSource = (payload) => ({
	type: pageTypes.SET_PUBLIC_LAST_MATCH_SOURCE,
	payload,
});

export const setPublicMatchHistory = (payload) => ({
	type: pageTypes.SET_PUBLIC_MATCH_HISTORY,
	payload,
});

export const setRank = (payload) => ({
	type: pageTypes.SET_RANK,
	payload,
});

export const setDiagramRatings = (payload) => ({
	type: pageTypes.SET_DIAGRAM_RATINGS,
	payload,
});

export const setRole = (payload) => ({
	type: pageTypes.SET_ROLE,
	payload,
});

export const setRatings = (payload) => ({
	type: pageTypes.SET_RATINGS,
	payload,
});

export const setAimRatings = (payload) => ({
	type: pageTypes.SET_AIM_RATINGS,
	payload,
});

export const setAimRole = (payload) => ({
	type: pageTypes.SET_AIM_ROLE,
	payload,
});

export const setAimRanksStats = (payload) => ({
	type: pageTypes.SET_AIM_RANK_STATS,
	payload,
});

export const setDiagramRankStats = (payload) => ({
	type: pageTypes.SET_DIAGRAM_RANK_STATS,
	payload,
});

export const setLastMatchInfo = (payload) => ({
	type: pageTypes.SET_LAST_MATCH_INFO,
	payload,
});

export const setRankStats = (payload) => ({
	type: pageTypes.SET_RANK_STATS,
	payload,
});

export const setPlayersRankStats = (payload) => ({
	type: pageTypes.SET_PLAYERS_RANK_STATS,
	payload,
});

export const setCardsStats = (payload) => ({
	type: pageTypes.SET_CARDS_STATS,
	payload,
});

export const setRankStatsV2 = (payload) => ({
	type: pageTypes.SET_RANK_STATS_V2,
	payload,
});

export const setPlayerClips = (payload) => ({
	type: pageTypes.SET_PLAYER_CLIPS,
	payload,
});

export const setPlayerPlaceholderClips = (payload) => ({
	type: pageTypes.SET_PLAYER_PLACEHOLDER_CLIPS,
	payload,
});

export const setUtilityRatings = (payload) => ({
	type: pageTypes.SET_UTILITY_RATINGS,
	payload,
});

export const setUtilityRole = (payload) => ({
	type: pageTypes.SET_UTILITY_ROLE,
	payload,
});

export const setUtilityRanksStats = (payload) => ({
	type: pageTypes.SET_UTILITY_RANK_STATS,
	payload,
});

export const setRankToRatings = (payload) => ({
	type: pageTypes.SET_RANK_TO_RATINGS,
	payload,
});
